//
//
//
//
//
//
//
//
//

export default {
  name: 'mt-cell-group',
  props: {
    title: {
      type:String,
      default: ""
    },
    grouppaddingleft: {
      type: String,
      default: ''
    }
  }
};



// WEBPACK FOOTER //
// ./packages/cell-group/src/cell-group.vue